import { useContext } from "react";
import { QueryObserverResult, useQuery } from "react-query";
import { useLocation } from "react-router-dom";
import { AppDivisionContext } from "../contexts/AppDivisionContext";
import { useOffline} from "../contexts/OfflineContext";
import divisionApi from "../utils/api/division";
import projectApi, { Project } from "../utils/api/project";
import db from "../db/db";

export function useProject(projectId: number): QueryObserverResult<Project> {
  const location = useLocation();
  const isOffline = useOffline();

  const isArchive = location.pathname.includes("archive");
  const appDivisionContext = useContext(AppDivisionContext);

  const fetchProjectData = async () => {
  
    if (!isOffline) {
      // Fetch data from the API
      const data = isArchive
        ? await divisionApi.projects.archive.get(
            appDivisionContext.appDivisionId!,
            projectId,
          )
        : await projectApi.get(projectId);
   
        return data;
    } else {

      const data = await db.projects.get(Number(projectId));
  
      if (!data) {
        // Handle the case where no data is found in IndexedDB
        throw new Error("No offline data available");
      }
  
      return data;
    }
  };

  const query = useQuery({
    queryKey: ["project", isArchive, projectId],
    queryFn: fetchProjectData,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    refetchOnMount: true,
  });

  return query;
}
